<template>
    <v-main>
        <router-view />
        <FooterMenu v-if="notErrorPage"/>
    </v-main>
</template>

<script>
import FooterMenu from './core/FooterMenu.vue';

export default {
    name: 'core-view',
    components: {
        FooterMenu,
    },
    computed: {
        notErrorPage() {
            return this.$store.state.accessToken && this.$route && this.$route.name != "empty" && this.$route.name != "final";
        },
    },
};
</script>

<style>
</style>
